// Tri des articles pour la préparation : marque, puis catégorie, puis nom.
const norm = (s) =>
  (s || '')
    .toString()
    .toLocaleLowerCase('fr')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

export const prepSortItems = (items) =>
  [...(items || [])].sort((a, b) => {
    const ab = norm(a.brand);
    const bb = norm(b.brand);
    if (ab !== bb) {
      if (!ab) return 1; // sans marque → fin de liste
      if (!bb) return -1;
      return ab.localeCompare(bb);
    }
    const ac = norm(a.category);
    const bc = norm(b.category);
    if (ac !== bc) return ac.localeCompare(bc);
    return norm(a.product_name || a.name).localeCompare(norm(b.product_name || b.name));
  });
